<script setup lang="ts">
import { computed } from 'vue'
import LevelMeter from './LevelMeter.vue'
import * as da from '@/strings/da'
import { formatSeconds } from '@/lib/format'

const props = defineProps<{
	remoteLevel: number
	toneLevel: number
	remoteAudibleMs: number
	remoteElapsedMs: number
}>()

defineEmits<{ stop: [] }>()

const heard = computed(() => da.call.heardSeconds(
	formatSeconds(props.remoteAudibleMs),
	formatSeconds(props.remoteElapsedMs)
))
</script>

<template>
	<section class="call">
		<LevelMeter :label="da.call.ourAudio" :level="remoteLevel" :hint="heard" />
		<LevelMeter :label="da.call.yourAudio" :level="toneLevel" :hint="da.call.sendingTone" />

		<button type="button" class="btn btn-tcx-outline btn-sm" @click="$emit('stop')">
			{{ da.page.stop }}
		</button>
	</section>
</template>

<style scoped>
.call {
	display: flex;
	flex-direction: column;
	gap: 16px;
	align-items: flex-start;
	padding: 18px 20px;
	border: 1px solid var(--tcx-line);
	border-radius: var(--tcx-radius-sm);
	background: #fafbfb;
}

.call > :deep(.meter) {
	width: 100%;
}
</style>
